import { Component, Input, OnInit, inject, DestroyRef } from '@angular/core';
import { translate } from '@jsverse/transloco';
import { instanceColumns } from 'src/app/models/instance/instance-column';
import { tenantColumns } from 'src/app/models/tenant/tenant-column';
import { instanceRoute } from 'src/app/models/instance/instance-route';
import { dbColumn } from 'src/app/models/instance/db-column';
import { FilterItem } from 'src/app/models/filter/filter-item';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { MatDialog } from '@angular/material/dialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { solutionColumns, SolutionColumn } from 'src/app/models/solutions/solution-column';
import { Subscription } from 'rxjs';
import { changeTaskColumn } from 'src/app/models/change-task/change-task-column';
import { subscriptionColumns } from 'src/app/models/instance/subscription-column';
import { instanceActivityColumns } from 'src/app/models/instance/instance-activity-column';
import { serviceDefColumns } from 'src/app/models/solutions/service-def-filter-column';
import { localConfigColumns } from 'src/app/models/instance/local-config-column';
import moment from 'moment';

@Component({
    selector: 'app-column-filter',
    templateUrl: './column-filter.component.html',
    styleUrls: ['./column-filter.component.scss'],
    standalone: false
})
export class ColumnFilterComponent  implements OnInit {
private destroyRef = inject(DestroyRef);
private isResetting = false;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() filteredColumns: string;
  @Input() type: any;
  @Input() status: any;
  @Input() tenant: any;
  @Input() name: any;
  @Input() region: any;
  @Input() cloud: any;
  @Input() lineOfBusiness: any;
  @Input() category: any;
  @Input() solution: any;
  @Input() page: any;
  @Input() direction: any;
  @Input() action: any;
  @Input() startDate: any;
  @Input() endDate: any;
  @Input() isMultiSelect = false;
  @Input() dbType: any;
  @Input() dbName: any;
  @Input() dbColumns: any;
  @Input() JBStatus: any;
  @Input() JBZone: any;
  @Input() JBDate: any;
  @Input() jumpboxColumns: any;
  @Input() filterModifiedStartDate: Date;
  @Input() filterModifiedEndDate: Date;
  @Input() privateEndpointsColumns: any;
  @Input() PEStatus: any;
  @Input() scheduleColumns: any;
  @Input() scheduleStatusList: any;
  @Input() scheduleTriggerList: any;
  @Input() scheduleDate: any;
  @Input() scheduleStartDate: any;
  @Input() scheduleEndDate: any;
  @Input() scheduleDetailColumns: any;
  @Input() scheduleStatusDetailList: any;
  @Input() scheduleDetailDate: any;
  @Input() scheduleDetailStartDate: any;
  @Input() scheduleDetailEndDate: any;
  @Input() inventoryTypeList: any;
  @Input() inventoryColumns: any;
   @Input() componentStatus: any;
  @Input() componentColumn:any;
  @Input() inventoryProdVersionList:any;
  @Input() inventoryProdIsManagedList:any;
  @Input() inventoryProductColumns: any;
  @Input() metricColumns: any
  @Input() metricAction: any;
  @Input() metricStartDate: any;
  @Input() metricEndDate: any;
  @Input() metricMinDate: any;
  @Input() metricMaxDate: any;
  @Input() customImageColumns: any;
  @Input() customCreatedBy: any;
  @Input() createdDate: any
  @Input() customImageStartDateChange: any;
  @Input() customImageEndDateChange: any;
  @Input() runbookColumns: any;
  @Input() runbookStartDateChange: any;
  @Input() runbookEndDateChange: any;
  @Input() modifiedDate: any;
  @Input() runbookVersionList: any;
  @Input() runbookStatusList: any;
  @Input() runbookTypeList: any;
  @Input() dateCreated: any;
  @Input() scheduleList: any;
  @Input() runbookList: any;
  @Input() statusList: any;
  @Input() Date: any;
  @Input() jobsColumns: any;
  @Input() envScheduleStartDateChange: any;
  @Input() envScheduleEndDateChange: any;
  @Input() envScheduleModifiedDate: any;
  @Input() envScheduleStatusList: any;
  @Input() envScheduleColumns: any;
  @Input() jobStartDateChange: any;
  @Input() jobEndDateChange: any;
  @Input() dbStartDateChange: any;
  @Input() dbEndDateChange: any;

  @Input() envJobDetailStartDateChange: any;
  @Input() envJobDetailEndDateChange: any;
  @Input() envJobDetailModifiedDate: any;
  @Input() envJobDetailStatusList: any;
  @Input() envJobDetailColumns: any;
  @Input() envdbDetailColumns: any;
  @Input() dbStatusList:any;
  @Input() dbNameList:any;
  @Input() dbTypeList:any;
  @Input() sanityTestColumns:any;
  @Input() sanityTestStatusList: any;
  @Input() serviceDefVersionList: any;
  @Input() startDateTest: any;
  @Input() endDateTest: any;
  @Input() sizingDocColumns: any;
  @Input() filterOptions: any;
  @Input() destinationType: any;

  maxDate: Date;

  allColumns;
  columnFilterItems: FilterItem<string>[] = [];
  dataListType = '';
  dataListTenant = [];
  dataListStatus = '';
  dataListDirection = '';
  dataListDestinationType = '';
  dataListRegion = '';
  dataListCloud = '';
  selected: any;
  subscription: Subscription;
  dataListLineOfBusiness = '';
  dataListCategory = '';
  isMultipleTenant = false;
  tenantMaxLimit = false;
  dataListAction = [];
  initialDataListAction = [];
  initialStartDate: Date;
  initialEndDate: Date;
  dataListSolution: any;
  JBStatusList = [];
  JBZoneList = [];
  JBDateList = [];
  validStartDate = false;
  validEndDate = false;
  validFilterModifiedStartDate = false;
  validFilterModifiedEndDate = false;
  PEStatusList = [];
  scheduleStatusSelList = [];
  inventoryTypeListData = [];
  scheduleTriggerSelList  = [];
  schDateSelList = [];
  validSchStartDate = false;
  validSchEndDate = false;
  scheduleStatusDetailSelList = [];
  schDateDetailSelList = [];
  validSchDetailStartDate = false;
  validSchDetailEndDate = false;
  componetStatusList = [];
  enableApplySchedule = false;
  inventoryProdVersionListData = [];
  inventoryProdIsManagedListData = [];
  metricListAction = [];
  metricDateSelected = false;
  enableApplyMetric = false;
  initialMetric = [];
  customImageCreatedByList = [];
  customImageDateList = [];
  validCustomStartDate = false;
  validCustomEndDate = false;

  runbookTypeSelList = [];
  runbookStatusSelList = [];
  runbookVersionSelList = [];
  dbTypeSelList = [];
  dbNameSelList = [];
  runbookDateList = [];
  validRunbookStartDate = false;
  validRunbookEndDate = false;
  envScheduleStatusSelList = [];
  envScheduleDateList = [];
  validEnvScheduleStartDate = false;
  validEnvScheduleEndDate = false;
  scheduleSelList = [];
  runbookSelList = [];
  statusSelList = [];
  DateSelList = [];
  validJobStartDate = false;
  validJobEndDate = false;
  envJobDetailStatusSelList = [];
  envJobDetailDateList = [];
  validEnvJobDetailStartDate = false;
  validEnvJobDetailEndDate = false;
  today = new Date();
  sanityTestSelList = [];
  sanityTestStatusSelList = [];
  enableApplySanityFilter = false;
  validStartDateChange = false;
  validEndDateChange = false;
  sizingVersionSelList = [];
  selectedDateList = [];
  versionSelList: any[];

  constructor(public sidenavService: SidenavService, private dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.initialStartDate = this.startDate;
    this.initialEndDate = this.endDate;
    this.metricAction?.forEach(item => {
      if (item?.selected === true) {
        this.initialMetric = [...this.initialMetric, item.value];
      }
    });
    this.action?.forEach(item => {
      if (item?.selected === true) {
        this.initialDataListAction = [...this.initialDataListAction, item];
      }
    });
    this.maxDate = new Date();
    this.subscription = this.sidenavService.searchFilter
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
    if(data !== 'data') {
      if (this.tenant?.find(item => item.value === data)) {
        this.selectOptionsTenant();
      } else if(this.status?.find(item => item.value === data)) {
        this.selectOptionsStatus();
      } else if(this.region?.find(item => item.value === data)) {
        this.selectOptionsRegion();
      } else if(this.cloud?.find(item => item.value === data)) {
        this.selectOptionsCloud();
      } else if(this.type?.find(item => item.value === data)) {
        this.selectOptionsType();
      } else if(this.direction?.find(item => item.value === data)) {
        this.selectOptionsDirection();
      } else if(this.lineOfBusiness?.find(item => item.value === data)) {
        this.selectOptionsLineOfBusiness();
      }  else if(this.category?.find(item => item.value === data)) {
        this.selectOptionsCategory();
      }  else if(this.solution?.find(item => item.value === data)) {
        this.selectOptionsSolutions();
      } else if (this.action?.find(item => item.value === data)) {
        this.selectOptionsAction();
      } else if (this.JBStatus?.find(item => item.value === data)) {
        this.selectOptionsJBStatus();
      } else if (this.JBZone?.find(item => item.value === data)) {
        this.selectOptionsJBZone();
      } else if (this.JBDate?.find(item => item.value === data)) {
        this.selectOptionsJBDate();
      } else if (this.PEStatus?.find(item => item.value === data)) {
        this.selectOptionsPEStatus();
      } else if (this.scheduleStatusSelList?.find(item => item.value === data)) {
        this.selectOptionsScheduleStatus();
      } else if (this.scheduleTriggerSelList?.find(item => item.value === data)) {
        this.selectOptionsScheduleTrigger();
      } else if (this.schDateSelList?.find(item => item.value === data)) {
        this.selectOptionsScheduleDate();
      } else if (this.scheduleStatusDetailSelList?.find(item => item.value === data)) {
        this.selectOptionsScheduleDetailStatus();
      } else if (this.schDateDetailSelList?.find(item => item.value === data)) {
        this.selectOptionsDetailScheduleDate();
      } else if (this.inventoryTypeListData?.find(item => item.value === data)) {
        this.selectOptionsInventoryCloud();
      }else if (this.componentStatus?.find(item => item.value === data)) {
        this.selectOptionsComponents();
      }else if (this.inventoryProdVersionListData?.find(item => item.value === data)) {
        this.selectOptionsInventoryProduct();
      }else if (this.inventoryProdIsManagedListData?.find(item => item.value === data)) {
        this.selectOptionsInventoryIsManaged();
      }else if (this.metricAction?.find(item => item.value === data)) {
        this.selectMetricAction();
      }else if (this.customImageCreatedByList?.find(item => item.value === data)) {
        this.selectOptionsCustomImageCreated();
      }else if (this.customImageDateList?.find(item => item.value === data)) {
        this.selectOptionsCustomImageDate();
      }else if (this.runbookTypeSelList?.find(item => item.value === data)) {
        this.selectOptionsRunbookType();
      }else if (this.runbookStatusSelList?.find(item => item.value === data)) {
        this.selectOptionsRunbookStatus();
      }else if (this.runbookVersionSelList?.find(item => item.value === data)) {
        this.selectOptionsRunbookVersion();
      }else if (this.runbookDateList?.find(item => item.value === data)) {
        this.selectOptionsRunbookDate();
      }else if (this.scheduleSelList?.find(item => item.value === data)) {
        this.selectOptionsJobSchedule();
      }else if (this.runbookSelList?.find(item => item.value === data)) {
        this.selectOptionsJobSRunbook();
      }else if (this.statusSelList?.find(item => item.value === data)) {
        this.selectOptionsJobsStatus();
      }else if (this.DateSelList?.find(item => item.value === data)) {
        this.selectOptionsJobsDate();
      } else if(this.envScheduleStatusSelList?.find(item => item.value === data)) {
        this.selectOptionsEnvScheduleStatus();
      }else if (this.envScheduleDateList?.find(item => item.value === data)) {
        this.selectOptionsEnvScheduleDate();
      } else if(this.envJobDetailStatusSelList?.find(item => item.value === data)) {
        this.selectOptionsEnvJobDetailstatus();
      }else if (this.envJobDetailDateList?.find(item => item.value === data)) {
        this.selectOptionsEnvJobDetailsDate();
      }else if (this.dbTypeSelList?.find(item => item.value === data)) {
        this.selectOptionDBType();
      }else if (this.dbNameSelList?.find(item => item.value === data)) {
        this.selectOptionDBName();
      }else if (this.dbStatusList?.find(item => item.value === data)) {
        this.selectOptionsDBStatus();
      }else if (this.sanityTestStatusSelList?.find(item => item.value === data)) {
        this.selectOptionsSanityTestStatus();
      } else if(this.destinationType?.find(item => item.value === data)) {
        this.selectOptionsDestinationType();
      }
      this.applyFilter();
    } else {
      this.resetFilterColumn();
    }
    });
    if (this.name === 'Environment') {
      this.allColumns = instanceColumns;
      this.isMultipleTenant = true;
    } else if(this.name === 'Route') {
      this.allColumns = instanceRoute;
    }else if(this.name === 'Db') {
      this.allColumns = this.dbColumns;
    } else if(this.name === 'Tenant') {
      this.allColumns = tenantColumns;
    } else if(this.name === 'Solution') {
      this.allColumns = solutionColumns;
      if (this.page === 'continuous_updates') {
       const filterColumns = this.allColumns.filter(item => item !== SolutionColumn.TENANT);
       this.allColumns = filterColumns;
      }
    } else if(this.name === 'Solutions') {
      this.allColumns = changeTaskColumn;
    } else if(this.name === 'Subscription') {
      this.allColumns = subscriptionColumns;
    } else if(this.name === 'InstanceActivity') {
      this.allColumns = instanceActivityColumns;
    } else if (this.name === 'LocalConfig') {
      this.allColumns = localConfigColumns;
    } else if(this.page === 'service_def') {
      this.allColumns = serviceDefColumns;
    } else if(this.name === 'Jumpbox') {
      this.allColumns = this.jumpboxColumns;
    } else if(this.name === 'privateendpoints') {
      this.allColumns = this.privateEndpointsColumns;
    } else if(this.name === 'scheduleFilters') {
      this.allColumns = this.scheduleColumns;
    } else if(this.name === 'scheduleDetailFilters') {
      this.allColumns = this.scheduleDetailColumns;
    } else if(this.name === 'inventoryFilters') {
      this.allColumns = this.inventoryColumns;
    }else if(this.name === 'Components') {
      this.allColumns = this.componentColumn;
    }else if(this.name === 'ProdVersionFilters') {
      this.allColumns = this.inventoryProductColumns;
    }else if(this.name === 'Metrics') {
      this.allColumns = this.metricColumns;
    }else if(this.name === 'Custom Image') {
      this.allColumns = this.customImageColumns;
    }else if(this.name === 'Runbook') {
      this.allColumns = this.runbookColumns;
    }else if(this.name === 'Jobs') {
      this.allColumns = this.jobsColumns;
    }else if(this.name === 'Schedule') {
      this.allColumns = this.envScheduleColumns;
    }else if(this.name === 'Job Details') {
      this.allColumns = this.envJobDetailColumns;
    }else if(this.name === 'Database Backup') {
      this.allColumns = this.envdbDetailColumns;
    }else if(this.name === 'Sanity Test') {
      this.allColumns = this.sanityTestColumns;
    }else if(this.name === 'Sizing Documents') {
      this.allColumns = this.sizingDocColumns;
    }else if(this.name === 'BaseImage') {
      this.allColumns = ['date'];
    }
    this.configureColumnFilterItems(false);
    if (this.tenant?.filter(item=> item.selected == true).length === 5) {
      this.tenantMaxLimit = true;
    }

    if (this.JBDate?.length) {
      if (this.JBDate[0]?.selected) {
        this.validStartDate = moment(this.startDate).isValid() ? true : false;
        this.validEndDate = moment(this.endDate).isValid() ? true : false;
      }
      if (this.JBDate[1]?.selected) {
        this.validFilterModifiedStartDate = moment(this.filterModifiedStartDate).isValid() ? true : false;
        this.validFilterModifiedEndDate = moment(this.filterModifiedEndDate).isValid() ? true : false;
      }
    }

    if (this.scheduleDate?.length) {
      if (this.scheduleDate[0]?.selected) {
        this.validSchStartDate = moment(this.scheduleStartDate).isValid() ? true : false;
        this.validSchEndDate = moment(this.scheduleEndDate).isValid() ? true : false;
      }
    }

    if (this.scheduleDetailDate?.length) {
      if (this.scheduleDetailDate[0]?.selected) {
        this.validSchDetailStartDate = moment(this.scheduleDetailStartDate).isValid() ? true : false;
        this.validSchDetailEndDate = moment(this.scheduleDetailEndDate).isValid() ? true : false;
      }
    }

    if (this.createdDate?.length) {
      if (this.createdDate[0]?.selected) {
        this.validCustomStartDate = moment(this.customImageStartDateChange).isValid() ? true : false;
        this.validCustomEndDate = moment(this.customImageEndDateChange).isValid() ? true : false;
      }
    }

    if (this.modifiedDate?.length) {
      if (this.modifiedDate[0]?.selected) {
        this.validRunbookStartDate = moment(this.runbookStartDateChange).isValid() ? true : false;
        this.validRunbookEndDate = moment(this.runbookEndDateChange).isValid() ? true : false;
      }
    }

     if (this.envScheduleModifiedDate?.length) {
      if (this.envScheduleModifiedDate[0]?.selected) {
        this.validEnvScheduleStartDate = moment(this.envScheduleStartDateChange).isValid() ? true : false;
        this.validEnvScheduleEndDate = moment(this.envScheduleEndDateChange).isValid() ? true : false;
      }
    }

    if (this.envJobDetailModifiedDate?.length) {
      if (this.envJobDetailModifiedDate[0]?.selected) {
        this.validEnvJobDetailStartDate = moment(this.envJobDetailStartDateChange).isValid() ? true : false;
        this.validEnvJobDetailEndDate = moment(this.envJobDetailEndDateChange).isValid() ? true : false;
      }
    }

     if (this.filterOptions?.length) {
      if (this.filterOptions[0]?.selected) {
        this.validStartDateChange = moment(this.startDateTest).isValid() ? true : false;
        this.validEndDateChange = moment(this.endDateTest).isValid() ? true : false;
      }
    }

    if (this.Date?.length) {
          if (this.Date[0]?.selected) {
            this.validJobStartDate = moment(this.jobStartDateChange).isValid() ? true : false;
            this.validJobEndDate = moment(this.jobEndDateChange).isValid() ? true : false;
          }
        }

    this.sidenavService.filterOutsideClick.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data === 'clear') {
          this.clearData();
        }
      });
  }

  /**
   * Select or deselect the columns to be used for filtering purposes
   *
   * @param columnFilterItem - the filter item selected/deselected
   */
  selectFilter(columnFilterItem): void {
    columnFilterItem.selected = !columnFilterItem.selected;
  }

  showFilter(columnFilterItem): void {
    columnFilterItem.selected = !columnFilterItem.selected;
  }

  metricStartDateChange(event){
    this.metricStartDate = event.value;
    this.metricDateSelected = this.metricEndDate && this.metricStartDate ? true : false;
  }

  metricEndDateChange(event){
    this.metricEndDate = event.value;
    this.metricDateSelected = this.metricEndDate && this.metricStartDate ? true : false;
  }

  selectMetricAction(item?): void {
    if (item) {
      item.selected = !item.selected;
      this.metricListAction = [];
      for (const items of this.metricAction) {
        if (items.selected) {
          this.metricListAction.push(items.value);
        }
      }
      this.metricListAction = [...new Set(this.metricListAction)];
      this.enableApplyMetric = JSON.stringify([...this.initialMetric].sort()) !== JSON.stringify([...this.metricListAction].sort()) ;
    }
  }

  selectOptionsTenant(item?): void {
    if(this.isMultipleTenant) {
      if(item) {
        item.selected = !item.selected;
        const selectedTenants = this.tenant.filter(item=> item.selected == true);
        if (selectedTenants.length <= 5 ) {
          this.dataListTenant = [];
          for (const items of this.tenant) {
            if (items.selected) {
              this.dataListTenant.push(items.value);
            }
          }
          this.dataListTenant = [...new Set(this.dataListTenant)];
          this.tenantMaxLimit = selectedTenants.length === 5? true: false;
        } else {
          item.selected = !item.selected;
          this.tenantMaxLimit = true;
        }
      }
    } else {
      if(this.tenant) {
        for (const items of this.tenant) {
          if (items.selected) {
            items.selected = false;
          }
        }
      }
      if(item) {
      item.selected = !item.selected;
      this.dataListTenant= item.value;
      };
    }
  }

  selectOptionsRegion(item?): void {
    this.dataListRegion = '';
    if(this.region) {
      for (const items of this.region) {
        if (items.selected) {
          items.selected = false;
        }
      }
    }
    if(item) {
    item.selected = !item.selected;
    this.dataListRegion= item.value;
    };
  }

  selectOptionsCloud(item?): void {
    this.dataListCloud = '';
    if(this.cloud) {
      for (const items of this.cloud) {
        if (items.selected) {
          items.selected = false;
        }
      }
    }
    if(item) {
    item.selected = !item.selected;
    this.dataListCloud= item.value;
    };
  }

  selectOptionsType(item?): void {
    this.dataListType= '';
    if(this.type) {
      for (const items of this.type) {
        if (items.selected) {
          items.selected = false;
        }
      }
    }
    if(item) {
    item.selected = !item.selected;
    this.dataListType= item.value;
    };
  }

  selectOptionsStatus(item?): void {
    if (this.isMultiSelect) {
      if (item) {
        item.selected = !item.selected;
        this.dbStatusList = [];
        for (const items of this.status) {
          if (items.selected) {
            this.dbStatusList.push(items.value);
          }
        }
        this.dbStatusList = [...new Set(this.dbStatusList)];
      }
    } else {
      this.dataListStatus = '';
      if(this.status) {
        for (const items of this.status) {
          if (items.selected) {
            items.selected = false;
          }
        }
      }
      if(item) {
      item.selected = !item.selected;
      this.dataListStatus = item.value;
      };
    }
  }

  selectOptionsDbType(item?): void {
    if (this.isMultiSelect) {
      if (item) {
        item.selected = !item.selected;
        this.dbTypeList = [];
        for (const items of this.dbType) {
          if (items.selected) {
            this.dbTypeList.push(items.value);
          }
        }
        this.dbTypeList = [...new Set(this.dbTypeList)];
      }
    }
  }

  selectOptionsDbName(item?): void {
    if (this.isMultiSelect) {
      if (item) {
        item.selected = !item.selected;
        this.dbNameList = [];
        for (const items of this.dbName) {
          if (items.selected) {
            this.dbNameList.push(items.value);
          }
        }
        this.dbNameList = [...new Set(this.dbNameList)];
      }
    }
  }

  selectOptionsDirection(item?): void {
    this.dataListDirection = '';
    if(this.direction) {
      for (const items of this.direction) {
        if (items.selected) {
          items.selected = false;
        }
      }
    }
    if(item) {
    item.selected = !item.selected;
    this.dataListDirection = item.value;
    };
  }
  selectOptionsDestinationType(item?): void {
    this.dataListDestinationType = '';
    if(this.destinationType) {
      for (const items of this.destinationType) {
        if (items.selected) {
          items.selected = false;
        }
      }
    }
    if(item) {
    item.selected = !item.selected;
    this.dataListDestinationType = item.value;
    };
  }

  selectOptionsLineOfBusiness(item?): void {
    this.dataListLineOfBusiness = '';
    if(this.lineOfBusiness) {
      for (const items of this.lineOfBusiness) {
        if (items.selected) {
          items.selected = false;
        }
      }
    }
    if(item) {
    item.selected = !item.selected;
    this.dataListLineOfBusiness = item.value;
    };
  }

  selectOptionsCategory(item?): void {
    this.dataListCategory = '';
    if(this.category) {
      for (const items of this.category) {
        if (items.selected) {
          items.selected = false;
        }
      }
    }
    if(item) {
    item.selected = !item.selected;
    this.dataListCategory = item.value;
    };
  }

  selectOptionsSolutions(item?): void {
    this.dataListSolution = '';
    if(this.solution) {
      for (const items of this.solution) {
        if (items.selected) {
          items.selected = false;
        }
      }
    }
    if(item) {
    item.selected = !item.selected;
    this.dataListSolution = item;
    };
  }

  selectOptionsAction(item?): void {
    if (item) {
      item.selected = !item.selected;
      this.dataListAction = [];
      for (const items of this.action) {
        if (items.selected) {
          this.dataListAction.push(items.value);
        }
      }
      this.dataListAction = [...new Set(this.dataListAction)];
    }
  }

  selectOptionsJBStatus(item?): void {
    if (item) {
      item.selected = !item.selected;
      this.JBStatusList = [];
      for (const items of this.JBStatus) {
        if (items.selected) {
          this.JBStatusList.push(items.value);
        }
      }
      this.JBStatusList = [...new Set(this.JBStatusList)];
    }
  }

  selectOptionsJBZone(item?): void {
    if (item) {
      item.selected = !item.selected;
      this.JBZoneList = [];
      for (const items of this.JBZone) {
        if (items.selected) {
          this.JBZoneList.push(items.value);
        }
      }
      this.JBZoneList = [...new Set(this.JBZoneList)];
    }
  }

  selectOptionsJBDate(item?): void {
    if (item) {
      item.selected = !item.selected;
      this.JBDateList = [];
      for (const items of this.JBDate) {
        if (items.selected) {
          this.JBDateList.push(items.value);
        }
      }
      this.JBDateList = [...new Set(this.JBDateList)];
    }
  }

  selectOptionsCustomImageDate(item?): void {
    if (item) {
      item.selected = !item.selected;
      this.customImageDateList = [];
      for (const items of this.createdDate) {
        if (items.selected) {
          this.customImageDateList.push(items.value);
        }
      }
      this.customImageDateList = [...new Set(this.customImageDateList)];
    }
  }

  selectOptionsPEStatus(item?): void {
    if (item) {
      item.selected = !item.selected;
      this.PEStatusList = [];
      for (const items of this.PEStatus) {
        if (items.selected) {
          this.PEStatusList.push(items.value);
        }
      }
      this.PEStatusList = [...new Set(this.PEStatusList)];
    }
  }

  selectOptionsComponents(item?): void {
    if (item) {
      item.selected = !item.selected;
      this.componetStatusList = [];
      for (const items of this.componentStatus) {
        if (items.selected) {
          this.componetStatusList.push(items.value);
        }
      }
      this.componetStatusList = [...new Set(this.componetStatusList)];
    }
  }

  selectOptionsScheduleStatus(item?): void {
    if (item) {
      this.enableApplySchedule = true;
      item.selected = !item.selected;
      this.scheduleStatusSelList = [];
      for (const items of this.scheduleStatusList) {
        if (items.selected) {
          this.scheduleStatusSelList.push(items.value);
        }
      }
      this.scheduleStatusSelList = [...new Set(this.scheduleStatusSelList)];
    }
  }

  selectOptionsCustomImageCreated(item?): void {
    if (item) {
      this.enableApplySchedule = true;
      item.selected = !item.selected;
      this.customImageCreatedByList = [];
      for (const items of this.customCreatedBy) {
        if (items.selected) {
          this.customImageCreatedByList.push(items.value);
        }
      }
      this.customImageCreatedByList = [...new Set(this.customImageCreatedByList)];
    }
  }

   selectOptionsRunbookType(item?): void {
    if (item) {
      this.enableApplySchedule = true;
      item.selected = !item.selected;
      this.runbookTypeSelList = [];
      for (const items of this.runbookTypeList) {
        if (items.selected) {
          this.runbookTypeSelList.push(items.value);
        }
      }
      this.runbookTypeSelList = [...new Set(this.runbookTypeSelList)];
    }
  }

  selectOptionsRunbookStatus(item?): void {
    if (item) {
      this.enableApplySchedule = true;
      item.selected = !item.selected;
      this.runbookStatusSelList = [];
      for (const items of this.runbookStatusList) {
        if (items.selected) {
          this.runbookStatusSelList.push(items.value);
        }
      }
      this.runbookStatusSelList = [...new Set(this.runbookStatusSelList)];
    }
  }

  selectOptionsEnvScheduleStatus(item?): void {
    if (item) {
      this.enableApplySchedule = true;
      item.selected = !item.selected;
      this.envScheduleStatusSelList = [];
      for (const items of this.envScheduleStatusList) {
        if (items.selected) {
          this.envScheduleStatusSelList.push(items.value);
        }
      }
      this.envScheduleStatusSelList = [...new Set(this.envScheduleStatusSelList)];
    }
  }

  selectOptionsEnvJobDetailstatus(item?): void {
    if (item) {
      this.enableApplySchedule = true;
      item.selected = !item.selected;
      this.envJobDetailStatusSelList = [];
      for (const items of this.envJobDetailStatusList) {
        if (items.selected) {
          this.envJobDetailStatusSelList.push(items.value);
        }
      }
      this.envJobDetailStatusSelList = [...new Set(this.envJobDetailStatusSelList)];
    }
  }

  selectOptionsRunbookVersion(item?): void {
    if (item) {
      this.enableApplySchedule = true;
      item.selected = !item.selected;
      this.runbookVersionSelList = [];
      for (const items of this.runbookVersionList) {
        if (items.selected) {
          this.runbookVersionSelList.push(items.value);
        }
      }
      this.runbookVersionSelList = [...new Set(this.runbookVersionSelList)];
    }
  }

  selectOptionsRunbookDate(item?): void {
    if (item) {
      this.enableApplySchedule = true;
      item.selected = !item.selected;
      this.runbookDateList = [];
      for (const items of this.modifiedDate) {
        if (items.selected) {
          this.runbookDateList.push(items.value);
        }
      }
      this.runbookDateList = [...new Set(this.runbookDateList)];
    }
  }

  selectOptionsEnvScheduleDate(item?): void {
    if (item) {
      this.enableApplySchedule = true;
      item.selected = !item.selected;
      this.envScheduleDateList = [];
      for (const items of this.envScheduleModifiedDate) {
        if (items.selected) {
          this.envScheduleDateList.push(items.value);
        }
      }
      this.envScheduleDateList = [...new Set(this.envScheduleDateList)];
    }
  }

  selectOptionsEnvJobDetailsDate(item?): void {
    if (item) {
      this.enableApplySchedule = true;
      item.selected = !item.selected;
      this.envJobDetailDateList = [];
      for (const items of this.envJobDetailModifiedDate) {
        if (items.selected) {
          this.envJobDetailDateList.push(items.value);
        }
      }
      this.envJobDetailDateList = [...new Set(this.envJobDetailDateList)];
    }
  }

   selectOptionsJobSchedule(item?): void {
    if (item) {
      this.enableApplySchedule = true;
      item.selected = !item.selected;
      this.scheduleSelList = [];
      for (const items of this.scheduleList) {
        if (items.selected) {
          this.scheduleSelList.push(items.value);
        }
      }
      this.scheduleSelList = [...new Set(this.scheduleSelList)];
    }
  }

   selectOptionsJobSRunbook(item?): void {
    if (item) {
      this.enableApplySchedule = true;
      item.selected = !item.selected;
      this.runbookSelList = [];
      for (const items of this.runbookList) {
        if (items.selected) {
          this.runbookSelList.push(items.value);
        }
      }
      this.runbookSelList = [...new Set(this.runbookSelList)];
    }
  }

   selectOptionsJobsStatus(item?): void {
    if (item) {
      this.enableApplySchedule = true;
      item.selected = !item.selected;
      this.statusSelList = [];
      for (const items of this.statusList) {
        if (items.selected) {
          this.statusSelList.push(items.value);
        }
      }
      this.statusSelList = [...new Set(this.statusSelList)];
    }
  }

   selectOptionsJobsDate(item?): void {
    if (item) {
      this.enableApplySchedule = true;
      item.selected = !item.selected;
      this.DateSelList = [];
      for (const items of this.Date) {
        if (items.selected) {
          this.DateSelList.push(items.value);
        }
      }
      this.DateSelList = [...new Set(this.DateSelList)];
    }
  }

   selectOptionsSizingVersion(item?): void {
    if (item) {
      this.enableApplySchedule = true;
      item.selected = !item.selected;
      this.sizingVersionSelList = [];
      for (const items of this.serviceDefVersionList) {
        if (items.selected) {
          this.sizingVersionSelList.push(items.value);
        }
      }
      this.sizingVersionSelList = [...new Set(this.sizingVersionSelList)];
    }
  }

   updateSelectedDate(item?): void {
    if (item) {
      this.enableApplySchedule = true;
      item.selected = !item.selected;
      this.selectedDateList = [];
      for (const items of this.filterOptions) {
        if (items.selected) {
          this.selectedDateList.push(items.value);
        }
      }
      this.selectedDateList = [...new Set(this.selectedDateList)];
    }
  }

  selectOptionsInventoryCloud(item?): void {
    if (item) {
      item.selected = !item.selected;
      this.inventoryTypeListData = [];
      for (const items of this.inventoryTypeList) {
        if (items.selected) {
          this.inventoryTypeListData.push(items.value);
        }
      }
      this.inventoryTypeListData = [...new Set(this.inventoryTypeListData)];
    }
  }

  selectOptionsInventoryProduct(item?): void {
    if (item) {
      item.selected = !item.selected;
      this.inventoryProdVersionListData = [];
      for (const items of this.inventoryProdVersionList) {
        if (items.selected) {
          this.inventoryProdVersionListData.push(items.value);
        }
      }
      this.inventoryProdVersionListData = [...new Set(this.inventoryProdVersionListData)];
    }
  }

  selectOptionsInventoryIsManaged(item?): void {
    if (item) {
      this.inventoryProdIsManagedListData = [];
      for (const items of this.inventoryProdIsManagedList) {
        if (items.selected) {
          items.selected = false;
        }
      }
      item.selected = !item.selected;
       this.inventoryProdIsManagedListData.push(item.value);
      this.inventoryProdIsManagedListData = [...new Set(this.inventoryProdIsManagedListData)];
    }
  }

  selectOptionsScheduleTrigger(item?): void {
    if (item) {
      this.enableApplySchedule = true;
      item.selected = !item.selected;
      this.scheduleTriggerSelList = [];
      for (const items of this.scheduleTriggerList) {
        if (items.selected) {
          this.scheduleTriggerSelList.push(items.value);
        }
      }
      this.scheduleTriggerSelList = [...new Set(this.scheduleTriggerSelList)];
    }
  }

  selectOptionsScheduleDate(item?): void {
    if (item) {
      this.enableApplySchedule = true;
      item.selected = !item.selected;
      this.schDateSelList = [];
      for (const items of this.scheduleDate) {
        if (items.selected) {
          this.schDateSelList.push(items.value);
        }
      }
      this.schDateSelList = [...new Set(this.schDateSelList)];
    }
  }

  selectOptionsScheduleDetailStatus(item?): void {
    if (item) {
      item.selected = !item.selected;
      this.scheduleStatusDetailSelList = [];
      for (const items of this.scheduleStatusDetailList) {
        if (items.selected) {
          this.scheduleStatusDetailSelList.push(items.value);
        }
      }
      this.scheduleStatusDetailSelList = [...new Set(this.scheduleStatusDetailSelList)];
    }
  }

  selectOptionsDetailScheduleDate(item?): void {
    if (item) {
      item.selected = !item.selected;
      this.schDateDetailSelList = [];
      for (const items of this.scheduleDetailDate) {
        if (items.selected) {
          this.schDateDetailSelList.push(items.value);
        }
      }
      this.schDateDetailSelList = [...new Set(this.schDateDetailSelList)];
    }
  }

  
   selectOptionDBType(item?): void {
    if (item) {
      this.enableApplySchedule = true;
      item.selected = !item.selected;
      this.dbTypeSelList = [];
      for (const items of this.dbTypeList) {
        if (items.selected) {
          this.dbTypeSelList.push(items.value);
        }
      }
      this.dbTypeSelList = [...new Set(this.dbTypeSelList)];
    }
  }
  
   selectOptionDBName(item?): void {
    if (item) {
      this.enableApplySchedule = true;
      item.selected = !item.selected;
      this.dbNameSelList = [];
      for (const items of this.dbNameList) {
        if (items.selected) {
          this.dbNameSelList.push(items.value);
        }
      }
      this.dbNameSelList = [...new Set(this.dbNameSelList)];
    }
  }
  
   selectOptionsDBStatus(item?): void {
    if (item) {
      this.enableApplySchedule = true;
      item.selected = !item.selected;
      this.statusSelList = [];
      for (const items of this.statusList) {
        if (items.selected) {
          this.statusSelList.push(items.value);
        }
      }
      this.statusSelList = [...new Set(this.statusSelList)];
    }
  }

  selectOptionsSanityTestStatus(item?): void {
    if (item) {
      this.enableApplySanityFilter = true;
      item.selected = !item.selected;
      this.sanityTestStatusSelList = [];
      for (const items of this.sanityTestStatusList) {
        if (items.selected) {
          this.sanityTestStatusSelList.push(items.value);
        }
      }
      this.sanityTestStatusSelList = [...new Set(this.sanityTestStatusSelList)];
    }
  }
  


  showHide(columnFilterItem): void {
    columnFilterItem.selected = !columnFilterItem.selected;
  }

  /**
   * Apply the column filtering to the whole table
   */
  applyFilter(reset?): void {
    this.selected = [];
    if (this.name === 'Environment') {
      if(reset) {
        if (this.isMultipleTenant) {
          this.tenant.filter(item=> item.selected = false);
          this.dataListTenant = undefined;
        } else {
          this.dataListTenant = undefined;
        }
        this.dataListStatus = undefined;
        this.dataListType = undefined;
      }
    this.selected.push(this.dataListTenant?.toString());
    this.selected.push(this.dataListStatus);
    this.selected.push(this.dataListType);
    } else if(this.name === 'Tenant') {
      if(reset) {
        this.dataListType = undefined;
        this.dataListRegion = undefined;
        this.dataListCloud = undefined;
        this.dataListStatus = undefined;
      }
      this.selected.push(this.dataListType);
      this.selected.push(this.dataListRegion);
      this.selected.push(this.dataListCloud);
      this.selected.push(this.dataListStatus);
    } else if(this.name === 'Solution') {
      if (reset) {
        this.dataListLineOfBusiness = undefined;
        this.dataListCategory = undefined;
        this.dataListRegion = undefined;
        this.dataListTenant = undefined;
      }
      this.selected.push(this.dataListLineOfBusiness);
      this.selected.push(this.dataListCategory);
      this.selected.push(this.dataListRegion);
      this.selected.push(this.dataListTenant);
    } else if(this.page === 'service_def') {
      if (reset) {
        this.dataListSolution = undefined;
      }
      this.selected.push(this.dataListSolution);
    } else if(this.name === 'Solutions') {
      if (reset) {
        this.dataListStatus = undefined;
      }
      this.selected.push(this.dataListStatus);
    } else if(this.name === 'Route') {
      if (reset) {
        this.dataListDirection = undefined;
        this.dataListStatus = undefined;
        this.dataListDestinationType = undefined;
      }
      this.selected.push(this.dataListDirection);
      this.selected.push(this.dataListStatus);
      this.selected.push(this.dataListDestinationType);
    } else if(this.name === 'Db') {
      if (reset) {
        if (this.isMultiSelect) {
          this.status.filter(item=> item.selected = false);
          this.dbType.filter(item=> item.selected = false);
          this.dbName.filter(item=> item.selected = false);
          this.dbStatusList = undefined;
          this.dbTypeList = undefined;
          this.dbNameList = undefined;
        } else {
          this.dataListStatus = undefined;
        }
      } else {
        if (this.isMultiSelect) {
          this.selected.push(this.dbStatusList?.toString());
          this.selected.push(this.dbTypeList?.toString());
          this.selected.push(this.dbNameList?.toString());
        } else {
          this.selected.push(this.dataListStatus);
        }
      }
    } else if(this.name === 'Subscription') {
      if(reset) {
        this.dataListTenant = undefined;
        this.dataListStatus = undefined;
      }
      this.selected.push(this.dataListTenant);
    } else if (this.name === 'InstanceActivity') {
      if (reset) {
        this.dataListAction = [];
        this.startDate = undefined;
        this.endDate = undefined;
      }
      if (this.dataListAction?.length === 0 && !reset) {
        this.action?.forEach(item => {
          if (item?.selected === true) {
            this.dataListAction = [...this.dataListAction, item?.value];
          }
        })
      }
      this.selected.push(this.dataListAction, {filteredStartDate: this.startDate, filteredEndDate: this.endDate});
    } else if (this.name === 'BaseImage') {
      if (reset) {
        this.startDate = undefined;
        this.endDate = undefined;
        this.filterOptions?.forEach((item: any) => item.selected = false);
      }
      this.selected.push({filteredStartDate: this.startDate, filteredEndDate: this.endDate});
    } else if (this.name === 'Jumpbox') {
      if (reset) {
        this.JBStatusList = [];
        this.JBZoneList =  [];
        this.JBDateList = [];
        this.startDate = undefined;
        this.endDate = undefined;
        this.filterModifiedEndDate = undefined;
        this.filterModifiedEndDate = undefined;
        this.JBStatus.filter(item=> item.selected = false);
        this.JBZone.filter(item=> item.selected = false);
        this.JBDate.filter(item=> item.selected = false);
      }
      if (this.JBStatusList?.length === 0 && !reset) {
        this.JBStatus?.forEach(item => {
          if (item?.selected === true) {
            this.JBStatusList = [...this.JBStatusList, item?.value];
          }
        })
      }
      if (this.JBZoneList?.length === 0 && !reset) {
        this.JBZone?.forEach(item => {
          if (item?.selected === true) {
            this.JBZoneList = [...this.JBZoneList, item?.value];
          }
        })
      }
      if (this.JBDateList?.length === 0 && !reset) {
        this.JBDate?.forEach(item => {
          if (item?.selected === true) {
            this.JBDateList = [...this.JBDateList, item?.value];
          }
        })
      }
      this.selected.push(this.JBStatusList);
      this.selected.push(this.JBZoneList);
      this.selected.push(this.JBDateList, {filteredStartDate: this.startDate, filteredEndDate: this.endDate});
      this.selected.push(this.JBDateList, {filteredModifiedStartDate: this.filterModifiedStartDate, filteredModifiedEndDate: this.filterModifiedEndDate});
    }

    else if (this.name === 'privateendpoints') {
      if (reset) {
        this.PEStatusList = [];
        this.PEStatus.filter(item=> item.selected = false);
      }
      if (this.PEStatusList?.length === 0 && !reset) {
        this.PEStatus?.forEach(item => {
          if (item?.selected === true) {
            this.PEStatusList = [...this.PEStatusList, item?.value];
          }
        })
      }
      this.selected.push(this.PEStatusList);
    }
    else if (this.name === 'scheduleFilters') {
      this.enableApplySchedule = false;
      if (reset) {
        this.scheduleStatusSelList = [];
        this.scheduleTriggerSelList =  [];
        this.schDateSelList = [];
        this.scheduleStartDate = undefined;
        this.scheduleEndDate = undefined;
        this.scheduleStatusList?.filter(item=> item.selected = false);
        this.scheduleTriggerList?.filter(item=> item.selected = false);
        this.scheduleDate?.filter(item=> item.selected = false);
      }
      if (this.scheduleStatusSelList?.length === 0 && !reset) {
        this.scheduleStatusList?.forEach(item => {
          if (item?.selected === true) {
            this.scheduleStatusSelList = [...this.scheduleStatusSelList, item?.value];
          }
        })
      }
      if (this.scheduleTriggerSelList?.length === 0 && !reset) {
        this.scheduleTriggerList?.forEach(item => {
          if (item?.selected === true) {
            this.scheduleTriggerSelList = [...this.scheduleTriggerSelList, item?.value];
          }
        })
      }
      if (this.schDateSelList?.length === 0 && !reset) {
        this.scheduleDate?.forEach(item => {
          if (item?.selected === true) {
            this.schDateSelList = [...this.schDateSelList, item?.value];
          }
        })
      }
      this.selected.push(this.scheduleStatusSelList);
      this.selected.push(this.scheduleTriggerSelList);
      this.selected.push(this.schDateSelList, {filteredStartDate: this.scheduleStartDate, filteredEndDate: this.scheduleEndDate});
    }
    else if (this.name === 'inventoryFilters') {
      if (reset) {
        this.inventoryTypeListData = [];
        this.inventoryTypeList?.filter(item=> item.selected = false);
      }
      if (this.inventoryTypeListData?.length === 0 && !reset) {
        this.inventoryTypeList?.forEach(item => {
          if (item?.selected === true) {
            this.inventoryTypeListData = [...this.inventoryTypeListData, item?.value];
          }
        })
      }
      this.selected.push(this.inventoryTypeListData);
    }
    else if (this.name === 'scheduleDetailFilters') {
      if (reset) {
        this.schDateDetailSelList = [];
        this.scheduleStatusDetailSelList = [];
        this.scheduleDetailStartDate = undefined;
        this.scheduleDetailEndDate = undefined;
        this.scheduleStatusDetailList?.filter(item=> item.selected = false);
        this.scheduleDetailDate?.filter(item=> item.selected = false);
      }
      if (this.scheduleStatusDetailSelList?.length === 0 && !reset) {
        this.scheduleStatusDetailList?.forEach(item => {
          if (item?.selected === true) {
            this.scheduleStatusDetailSelList = [...this.scheduleStatusDetailSelList, item?.value];
          }
        })
      }
      if (this.schDateDetailSelList?.length === 0 && !reset) {
        this.scheduleDetailDate?.forEach(item => {
          if (item?.selected === true) {
            this.schDateDetailSelList = [...this.schDateDetailSelList, item?.value];
          }
        })
      }
      this.selected.push(this.scheduleStatusDetailSelList);
      this.selected.push(this.schDateDetailSelList, {filteredStartDate: this.scheduleDetailStartDate, filteredEndDate: this.scheduleDetailEndDate});
    }else if (this.name === 'Components') {
      if (reset) {
        this.componetStatusList = [];
        this.componentStatus.filter(item=> item.selected = false);
      }
      if (this.componetStatusList?.length === 0 && !reset) {
        this.componetStatusList?.forEach(item => {
          if (item?.selected === true) {
            this.componentStatus = [...this.componetStatusList, item?.value];
          }
        })
      }
      this.selected.push(this.componetStatusList);
    } else if (this.name === 'ProdVersionFilters') {
      if (reset) {
        this.inventoryProdVersionListData = [];
        this.inventoryProdIsManagedListData =[];
        this.inventoryProdVersionList?.filter(item=> item.selected = false);
        this.inventoryProdIsManagedList?.filter(item=> item.selected = false);
      }
      if (this.inventoryProdVersionListData?.length === 0 && !reset) {
        this.inventoryProdVersionList?.forEach(item => {
          if (item?.selected === true) {
            this.inventoryProdVersionListData = [...this.inventoryProdVersionListData, item?.value];
          }
        })
      }
      if (this.inventoryProdIsManagedListData?.length === 0 && !reset) {
        this.inventoryProdIsManagedList?.forEach(item => {
          if (item?.selected === true) {
            this.inventoryProdIsManagedListData = [...this.inventoryProdIsManagedListData, item?.value];
          }
        })
      }
      this.selected.push(this.inventoryProdVersionListData);
      this.selected.push(this.inventoryProdIsManagedListData);
    }else if (this.name === 'Metrics') {
      this.enableApplyMetric = false;
      if (reset) {
        this.metricListAction = [];
        this.metricStartDate = undefined;
        this.metricEndDate = undefined;
      }
      if (this.metricListAction?.length === 0 && !reset) {
        this.metricAction?.forEach(item => {
          if (item?.selected === true) {
            this.metricListAction = [...this.metricListAction, item?.value];
          }
        })
      }
      this.selected.push(this.metricListAction, {filteredStartDate: this.metricStartDate, filteredEndDate: this.metricEndDate});
    }else if (this.name === 'Custom Image') {
      if (reset) {
        this.customImageCreatedByList = [];
        this.customImageDateList = [];
        this.customCreatedBy?.forEach(item => item.selected = false);
        this.createdDate?.filter(item=> item.selected = false);
        this.customImageStartDateChange = undefined;
        this.customImageEndDateChange = undefined;
      }
      if (this.customImageCreatedByList?.length === 0 && !reset) {
        this.customCreatedBy?.forEach(item => {
          if (item?.selected === true) {
            this.customImageCreatedByList = [...this.customImageCreatedByList, item?.value];
          }
        })
      }
      if (this.customImageDateList?.length === 0 && !reset) {
        this.createdDate?.forEach(item => {
          if (item?.selected === true) {
            this.customImageDateList = [...this.customImageDateList, item?.value];
          }
        })
      }
      this.selected.push(this.customImageCreatedByList);
      this.selected.push([...this.customImageDateList, {filteredStartDate: this.customImageStartDateChange, filteredEndDate: this.customImageEndDateChange}]);
    } else if (this.name === 'Runbook') {
      if (reset) {
        this.runbookTypeSelList = [];
        this.runbookStatusSelList = [];
        this.runbookVersionSelList = [];
        this.runbookDateList = [];
        this.runbookTypeList?.forEach(item => item.selected = false);
        this.runbookStatusList?.forEach(item => item.selected = false);
        this.runbookVersionList?.forEach(item => item.selected = false);
        this.modifiedDate?.filter(item=> item.selected = false);
        this.runbookStartDateChange = undefined;
        this.runbookEndDateChange = undefined;
      }
      if (this.runbookTypeSelList?.length === 0 && !reset) {
        this.runbookTypeList?.forEach(item => {
          if (item?.selected === true) {
            this.runbookTypeSelList = [...this.runbookTypeSelList, item?.value];
          }
        })
      }
      if (this.runbookStatusSelList?.length === 0 && !reset) {
        this.runbookStatusList?.forEach(item => {
          if (item?.selected === true) {
            this.runbookStatusSelList = [...this.runbookStatusSelList, item?.value];
          }
        })
      }
      if (this.runbookVersionSelList?.length === 0 && !reset) {
        this.runbookVersionList?.forEach(item => {
          if (item?.selected === true) {
            this.runbookVersionSelList = [...this.runbookVersionSelList, item?.value];
          }
        })
      }
      if (this.runbookDateList?.length === 0 && !reset) {
        this.modifiedDate?.forEach(item => {
          if (item?.selected === true) {
            this.runbookDateList = [...this.runbookDateList, item?.value];
          }
        })
      }
      this.selected.push(this.runbookTypeSelList);
      this.selected.push(this.runbookStatusSelList);
      this.selected.push(this.runbookVersionSelList);
      this.selected.push([...this.runbookDateList, {filteredStartDate: this.runbookStartDateChange, filteredEndDate: this.runbookEndDateChange}]);
      } else if (this.name === 'Schedule') {
      if (reset) {
        this.envScheduleStatusSelList = [];
        this.envScheduleDateList = [];
        this.envScheduleStatusList?.forEach(item => item.selected = false);
        this.envScheduleModifiedDate?.filter(item=> item.selected = false);
        this.envScheduleStartDateChange = undefined;
        this.envScheduleEndDateChange = undefined;
      }
      if (this.envScheduleStatusSelList?.length === 0 && !reset) {
        this.envScheduleStatusList?.forEach(item => {
          if (item?.selected === true) {
            this.envScheduleStatusSelList = [...this.envScheduleStatusSelList, item?.value];
          }
        })
      }
      if (this.envScheduleDateList?.length === 0 && !reset) {
        this.modifiedDate?.forEach(item => {
          if (item?.selected === true) {
            this.envScheduleDateList = [...this.envScheduleDateList, item?.value];
          }
        })
      }
      this.selected.push(this.envScheduleStatusSelList);
      this.selected.push([...this.envScheduleDateList, {filteredStartDate: this.envScheduleStartDateChange, filteredEndDate: this.envScheduleEndDateChange}]);
    }else if (this.name === 'Jobs') {
      if (reset) {
        this.scheduleSelList = [];
        this.runbookSelList = [];
        this.statusSelList = [];
        this.DateSelList = [];
        this.scheduleList?.forEach(item => item.selected = false);
        this.runbookList?.forEach(item => item.selected = false);
        this.statusList?.forEach(item => item.selected = false);
        this.Date?.filter(item=> item.selected = false);
        this.jobStartDateChange = undefined;
        this.jobEndDateChange = undefined;
      }
      if (this.scheduleSelList?.length === 0 && !reset) {
        this.scheduleList?.forEach(item => {
          if (item?.selected === true) {
            this.scheduleSelList = [...this.scheduleSelList, item?.value];
          }
        })
      }
      if (this.runbookSelList?.length === 0 && !reset) {
        this.runbookList?.forEach(item => {
          if (item?.selected === true) {
            this.runbookSelList = [...this.runbookSelList, item?.value];
          }
        })
      }
      if (this.statusSelList?.length === 0 && !reset) {
        this.statusList?.forEach(item => {
          if (item?.selected === true) {
            this.statusSelList = [...this.statusSelList, item?.value];
          }
        })
      }
      if (this.DateSelList?.length === 0 && !reset) {
        this.Date?.forEach(item => {
          if (item?.selected === true) {
            this.DateSelList = [...this.DateSelList, item?.value];
          }
        })
      }
      this.selected.push(this.scheduleSelList);
      this.selected.push(this.runbookSelList);
      this.selected.push(this.statusSelList);
      this.selected.push([...this.DateSelList, {filteredStartDate: this.jobStartDateChange, filteredEndDate: this.jobEndDateChange}]);
    } else if (this.name === 'Job Details') {
      if (reset) {
        this.envJobDetailStatusSelList = [];
        this.envJobDetailDateList = [];
        this.envJobDetailStatusList?.forEach(item => item.selected = false);
        this.envJobDetailModifiedDate?.filter(item=> item.selected = false);
        this.envJobDetailStartDateChange = undefined;
        this.envJobDetailEndDateChange = undefined;
      }
      if (this.envJobDetailStatusSelList?.length === 0 && !reset) {
        this.envJobDetailStatusList?.forEach(item => {
          if (item?.selected === true) {
            this.envJobDetailStatusSelList = [...this.envJobDetailStatusSelList, item?.value];
          }
        })
      }
      if (this.envJobDetailDateList?.length === 0 && !reset) {
        this.modifiedDate?.forEach(item => {
          if (item?.selected === true) {
            this.envJobDetailDateList = [...this.envJobDetailDateList, item?.value];
          }
        })
      }
      this.selected.push(this.envJobDetailStatusSelList);
      this.selected.push([...this.envJobDetailDateList, {filteredStartDate: this.envJobDetailStartDateChange, filteredEndDate: this.envJobDetailEndDateChange}]);
    }else if (this.name === 'Database Backup') {
      if (reset) {
        this.dbTypeSelList = [];
        this.dbNameSelList = [];
        this.statusSelList = [];
        this.dbTypeSelList?.forEach(item => item.selected = false);
        this.dbNameSelList?.forEach(item => item.selected = false);
        this.statusList?.forEach(item => item.selected = false);
      }
      if (this.dbTypeSelList?.length === 0 && !reset) {
        this.dbTypeList?.forEach(item => {
          if (item?.selected === true) {
            this.dbTypeSelList = [...this.dbTypeSelList, item?.value];
          }
        })
      }
      if (this.dbNameSelList?.length === 0 && !reset) {
        this.dbNameList?.forEach(item => {
          if (item?.selected === true) {
            this.dbNameSelList = [...this.dbNameSelList, item?.value];
          }
        })
      }
      if (this.statusSelList?.length === 0 && !reset) {
        this.statusList?.forEach(item => {
          if (item?.selected === true) {
            this.statusSelList = [...this.statusSelList, item?.value];
          }
        })
      }
      this.selected.push(this.statusSelList);
      this.selected.push(this.dbTypeSelList);
      this.selected.push(this.dbNameSelList);
    }  else if (this.name === 'Sanity Test') {
      if (reset) {
        this.sanityTestStatusSelList = [];
        this.sanityTestStatusList?.forEach(item => item.selected = false);
      }
      if (this.sanityTestStatusSelList?.length === 0 && !reset) {
        this.sanityTestStatusList?.forEach(item => {
          if (item?.selected === true) {
            this.sanityTestStatusSelList = [...this.sanityTestStatusSelList, item?.value];
          }
        })
      }
      this.selected.push(this.sanityTestStatusSelList);
      } else if (this.name === 'Sizing Documents') {
      if (reset) {
        this.sizingVersionSelList = [];
        this.selectedDateList = [];
        this.serviceDefVersionList?.forEach(item => item.selected = false);
        this.filterOptions?.filter(item=> item.selected = false);
        this.startDateTest = undefined;
        this.endDateTest = undefined;
      }
     
      if (this.sizingVersionSelList?.length === 0 && !reset) {
        this.serviceDefVersionList?.forEach(item => {
          if (item?.selected === true) {
            this.sizingVersionSelList = [...this.sizingVersionSelList, item?.value];
          }
        })
      }
      if (this.selectedDateList?.length === 0 && !reset) {
        this.filterOptions?.forEach(item => {
          if (item?.selected === true) {
            this.selectedDateList = [...this.selectedDateList, item?.value];
          }
        })
      }
      this.selected.push(this.sizingVersionSelList);
      this.selected.push([...this.selectedDateList, {filteredStartDate: this.startDateTest, filteredEndDate: this.endDateTest}]);
    } else if (this.name === 'LocalConfig') {
      if (reset) {
        this.selectedDateList = [];
        this.filterOptions?.forEach(item => item.selected = false);
        this.startDateTest = undefined;
        this.endDateTest = undefined;
      }
      if (this.selectedDateList?.length === 0 && !reset) {
        this.filterOptions?.forEach(item => {
          if (item?.selected) {
            this.selectedDateList.push(item.value);
          }
        });
      }
      this.selected.push(this.selectedDateList ?? []);
      this.selected.push({
        filteredStartDate: this.startDateTest ?? undefined,
        filteredEndDate: this.endDateTest ?? undefined
      });
    }

    this.sidenavService.closeRightSidenav(this.selected);
  }

  clearData(): void {
    this.tenant?.filter((item) => {
      if (this.isMultipleTenant) {
        this.dataListTenant.forEach(selectedItem => {
          this.tenant.find((item)=> item.value === selectedItem).selected = false;
        })
      } else if (item.value === this.dataListTenant){
        item.selected = false;
      }
    });

    this.status?.filter((item) => {
      if (item.value === this.dataListStatus){
        item.selected = false;
      }
    });

    this.direction?.filter((item) => {
      if (item.value === this.dataListDirection){
        item.selected = false;
      }
    });

    this.destinationType?.filter((item) => {
      if (item.value === this.dataListDestinationType){
        item.selected = false;
      }
    });

    this.type?.filter((item) => {
      if (item.value === this.dataListType){
        item.selected = false;
      }
    });

    this.region?.filter((item) => {
      if (item.value === this.dataListRegion){
        item.selected = false;
      }
    });

    this.cloud?.filter((item) => {
      if (item.value === this.dataListCloud){
        item.selected = false;
      }
    });

    this.category?.filter((item) => {
      if (item.value === this.dataListCategory){
        item.selected = false;
      }
    });
    this.solution?.filter((item) => {
      if (item.id === this.dataListSolution?.id){
        item.selected = false;
      }
    });

    this.lineOfBusiness?.filter((item) => {
      if (item.value === this.dataListLineOfBusiness){
        item.selected = false;
      }
    });
    this.action?.filter((item) => {
      this.dataListAction.forEach(selectedItem => {
        this.action.find((item)=> item.value === selectedItem).selected = false;
      })
    });
    this.JBStatus?.filter((item) => {
      this.JBStatusList.forEach(selectedItem => {
        this.JBStatus.find((item)=> item.value === selectedItem).selected = false;
      })
    });
    this.JBZone?.filter((item) => {
      this.JBZoneList.forEach(selectedItem => {
        this.JBZone.find((item)=> item.value === selectedItem).selected = false;
      })
    });
    this.JBDate?.filter((item) => {
      this.JBDateList.forEach(selectedItem => {
        this.JBDate.find((item)=> item.value === selectedItem).selected = false;
      })
    });

    this.scheduleStatusList?.filter((item) => {
      this.scheduleStatusSelList.forEach(selectedItem => {
        this.scheduleStatusList.find((item)=> item.value === selectedItem).selected = false;
      })
    });
    this.scheduleTriggerList?.filter((item) => {
      this.scheduleTriggerSelList.forEach(selectedItem => {
        this.scheduleTriggerList.find((item)=> item.value === selectedItem).selected = false;
      })
    });
    this.scheduleDate?.filter((item) => {
      this.schDateSelList.forEach(selectedItem => {
        this.scheduleDate.find((item)=> item.value === selectedItem).selected = false;
      })
    });
    this.scheduleStatusDetailList?.filter((item) => {
      this.scheduleStatusDetailSelList.forEach(selectedItem => {
        this.scheduleStatusDetailList.find((item)=> item.value === selectedItem).selected = false;
      })
    });
    this.scheduleDetailDate?.filter((item) => {
      this.schDateDetailSelList.forEach(selectedItem => {
        this.scheduleDetailDate.find((item)=> item.value === selectedItem).selected = false;
      })
    });
    this.inventoryTypeList?.filter((item) => {
      this.inventoryTypeListData.forEach(selectedItem => {
        this.inventoryTypeList.find((item)=> item.value === selectedItem).selected = false;
      })
    });
    this.componentStatus?.filter((item) => {
      this.componetStatusList.forEach(selectedItem => {
        this.componentStatus.find((item)=> item.value === selectedItem).selected = false;
      })
    });
    this.inventoryProdVersionList?.filter((item) => {
      this.inventoryProdVersionListData.forEach(selectedItem => {
        this.inventoryProdVersionList.find((item)=> item.value === selectedItem).selected = false;
      })
    });
    this.inventoryProdIsManagedList?.filter((item) => {
      this.inventoryProdIsManagedListData.forEach(selectedItem => {
        this.inventoryProdIsManagedList.find((item)=> item.value === selectedItem).selected = false;
      })
    });
    this.inventoryProdIsManagedList?.filter((item) => {
      if (item.value === this.dataListStatus){
        item.selected = false;
      }
    });
    this.metricAction?.filter((item) => {
      this.metricListAction.forEach(selectedItem => {
        this.metricAction.find((item)=> item.value === selectedItem).selected = false;
      })
    });
    this.customCreatedBy?.filter((item) => {
      this.customImageCreatedByList.forEach(selectedItem => {
        this.customCreatedBy.find((item)=> item.value === selectedItem).selected = false;
      })
    });
    this.createdDate?.filter((item) => {
      this.customImageDateList.forEach(selectedItem => {
        this.createdDate.find((item)=> item.value === selectedItem).selected = false;
      })
    });
    this.runbookTypeList?.filter((item) => {
      this.runbookTypeSelList.forEach(selectedItem => {
        this.runbookTypeList.find((item)=> item.value === selectedItem).selected = false;
      })
    });
    this.runbookStatusList?.filter((item) => {
      this.runbookStatusSelList.forEach(selectedItem => {
        this.runbookStatusList.find((item)=> item.value === selectedItem).selected = false;
      })
    });
	  this.runbookVersionList?.filter((item) => {
      this.runbookVersionSelList.forEach(selectedItem => {
        this.runbookVersionList.find((item)=> item.value === selectedItem).selected = false;
      })
    });
    this.modifiedDate?.filter((item) => {
      this.runbookDateList.forEach(selectedItem => {
        this.modifiedDate.find((item)=> item.value === selectedItem).selected = false;
      })
    });
    this.envScheduleStatusList?.filter((item) => {
      this.envScheduleStatusSelList.forEach(selectedItem => {
        this.envScheduleStatusList.find((item)=> item.value === selectedItem).selected = false;
      })
    });
    this.envJobDetailStatusList?.filter((item) => {
      this.envJobDetailStatusSelList.forEach(selectedItem => {
        this.envJobDetailStatusList.find((item)=> item.value === selectedItem).selected = false;
      })
    });
    this.envScheduleModifiedDate?.filter((item) => {
      this.envScheduleDateList.forEach(selectedItem => {
        this.envScheduleModifiedDate.find((item)=> item.value === selectedItem).selected = false;
      })
    });
    this.envJobDetailModifiedDate?.filter((item) => {
      this.envJobDetailDateList.forEach(selectedItem => {
        this.envJobDetailModifiedDate.find((item)=> item.value === selectedItem).selected = false;
      })
    });
     this.scheduleList?.filter((item) => {
      this.scheduleSelList.forEach(selectedItem => {
        this.scheduleList.find((item)=> item.value === selectedItem).selected = false;
      })
    });
     this.runbookList?.filter((item) => {
      this.runbookSelList.forEach(selectedItem => {
        this.runbookList.find((item)=> item.value === selectedItem).selected = false;
      })
    });
     this.statusList?.filter((item) => {
      this.statusSelList.forEach(selectedItem => {
        this.statusList.find((item)=> item.value === selectedItem).selected = false;
      })
    });
     this.Date?.filter((item) => {
      this.DateSelList.forEach(selectedItem => {
        this.Date.find((item)=> item.value === selectedItem).selected = false;
      })
    });
    this.sanityTestStatusList?.filter((item) => {
      this.sanityTestStatusSelList.forEach(selectedItem => {
        this.sanityTestStatusList.find((item)=> item.value === selectedItem).selected = false;
      })
    });
    this.serviceDefVersionList?.filter((item) => {
      this.sizingVersionSelList?.forEach(selectedItem => {
        this.serviceDefVersionList.find((item)=> item.value === selectedItem).selected = false;
      })
    });
    this.filterOptions?.filter((item) => {
      this.selectedDateList?.forEach(selectedItem => {
        this.filterOptions.find((item)=> item.value === selectedItem).selected = false;
      })
    });
  }
  /**
   * Resets the selected column filtering
   */
  resetFilterColumn(): void {
      if (this.isResetting) return;
      this.isResetting = true;
    if (this.name === 'Environment') {
      this.selectOptionsTenant();
      this.selectOptionsStatus();
      this.selectOptionsType();
      this.applyFilter('reset');
    } else if(this.name === 'Tenant') {
      this.selectOptionsType();
      this.selectOptionsRegion();
      this.selectOptionsCloud();
      this.selectOptionsStatus();
      this.applyFilter('reset');
    } else if(this.name === 'Route') {
      this.selectOptionsDirection();
      this.selectOptionsStatus();
      this.applyFilter('reset');
    } else if(this.name === 'Db') {
      this.selectOptionsStatus();
      this.applyFilter('reset');
    } else if (this.name === 'Solution') {
      this.selectOptionsLineOfBusiness();
      this.selectOptionsCategory();
      this.selectOptionsRegion();
      this.selectOptionsTenant();
      this.applyFilter('reset');
    }else if (this.page === 'service_def') {
      this.selectOptionsSolutions();
      this.applyFilter('reset');
    } else if (this.name === 'Solutions') {
      this.selectOptionsStatus();
      this.applyFilter('reset');
    }else if (this.name === 'Subscription') {
      this.selectOptionsTenant();
      this.applyFilter('reset');
    } else if(this.name === 'InstanceActivity') {
      this.selectOptionsAction();
      this.applyFilter('reset');
    } else if(this.name === 'BaseImage') {
      this.applyFilter('reset');
    } else if(this.name === 'Jumpbox') {
      this.selectOptionsJBStatus();
      this.selectOptionsJBZone();
      this.selectOptionsJBDate();
      this.applyFilter('reset');
    }
    else if(this.name === 'privateendpoints') {
      this.selectOptionsPEStatus();
      this.applyFilter('reset');
    }
    else if(this.name === 'scheduleFilters') {
      this.selectOptionsScheduleStatus();
      this.selectOptionsScheduleTrigger();
      this.selectOptionsScheduleDate();
      this.applyFilter('reset');
    }
    else if(this.name === 'scheduleDetailFilters') {
      this.selectOptionsScheduleDetailStatus();
      this.selectOptionsDetailScheduleDate();
      this.applyFilter('reset');
    }
    else if(this.name === 'inventoryFilters') {
      this.selectOptionsInventoryCloud();
      this.applyFilter('reset');
    }else if(this.name === 'Components'){
      this.selectOptionsComponents();
      this.applyFilter('reset');
    }else if(this.name === 'ProdVersionFilters') {
      this.selectOptionsInventoryProduct();
      this.selectOptionsInventoryIsManaged();
      this.applyFilter('reset');
    }else if(this.name === 'Metrics'){
      this.selectMetricAction();
      this.applyFilter('reset');
    }else if(this.name === 'Custom Image'){
      this.selectOptionsCustomImageDate();
      this.applyFilter('reset');
    }else if(this.name === 'Runbook'){
      this.selectOptionsRunbookType();
      this.selectOptionsRunbookStatus();
	    this.selectOptionsRunbookVersion();
	    this.selectOptionsRunbookDate();
      this.applyFilter('reset');
    }else if(this.name === 'Schedule') {
      this.selectOptionsEnvScheduleStatus();
	    this.selectOptionsEnvScheduleDate();
      this.applyFilter('reset');
    }else if(this.name === 'Jobs'){
      this.selectOptionsJobSRunbook();
      this.selectOptionsJobSchedule();
	    this.selectOptionsJobsStatus();
	    this.selectOptionsJobsDate();
      this.applyFilter('reset');
    }else if(this.name === 'Database Backup'){
      this.selectOptionDBType();
      this.selectOptionDBName();
	    this.selectOptionsDBStatus();
      this.applyFilter('reset');
    }else if(this.name === 'Job Details') {
      this.selectOptionsEnvJobDetailstatus();
	    this.selectOptionsEnvJobDetailsDate();
      this.applyFilter('reset');
    }else if(this.name === 'Sanity Test') {
      this.selectOptionsSanityTestStatus();
      this.applyFilter('reset');
    }else if(this.name === 'Sizing Documents') {
      this.selectOptionsSizingVersion();
      this.updateSelectedDate();
      this.applyFilter('reset');
    } else if (this.name === 'LocalConfig') {
      this.updateSelectedDate();
      this.applyFilter('reset');
    }
    this.isResetting = false;
  }

  startDateChange(event) {
    this.startDate = event.value;
    this.validStartDate = true;
    if (this.JBDate) {
      this.JBDate[0].selected = false;
      this.selectOptionsJBDate(this.JBDate[0]);
    }
  }

  endDateChange(event) {
    this.endDate = event.value;
    this.validEndDate = true;
    if (this.JBDate) {
      this.JBDate[0].selected = false;
      this.selectOptionsJBDate(this.JBDate[0]);
    }
  }

   scheduleStartDateChange(event) {
    this.scheduleStartDate = event.value;
    this.validSchStartDate = true;
    if (this.scheduleDate) {
      this.scheduleDate[0].selected = false;
      this.selectOptionsScheduleDate(this.scheduleDate[0]);
    }
  }

  customImagesStartDateChange(event) {
    this.customImageStartDateChange = event.value;
    this.validCustomStartDate = true;
    if (this.createdDate) {
      this.createdDate[0].selected = false;
      this.selectOptionsCustomImageDate(this.createdDate[0]);
    }
  }

  customImagesEndDateChange(event) {
    this.customImageEndDateChange = event.value;
    this.validCustomEndDate = true;
    if (this.createdDate) {
      this.createdDate[0].selected = false;
      this.selectOptionsCustomImageDate(this.createdDate[0]);
    }
  }

   runbookItemStartDateChange(event) {
    this.runbookStartDateChange = event.value;
    this.validRunbookStartDate = true;
    if (this.modifiedDate) {
      this.modifiedDate[0].selected = false;
      this.selectOptionsRunbookDate(this.modifiedDate[0]);
    }
  }

  runbookItemEndDateChange(event) {
    this.runbookEndDateChange = event.value;
    this.validRunbookEndDate = true;
    if (this.modifiedDate) {
      this.modifiedDate[0].selected = false;
      this.selectOptionsRunbookDate(this.modifiedDate[0]);
    }
  }

  envScheduleItemStartDateChange(event) {
    this.envScheduleStartDateChange = event.value;
    this.validEnvScheduleStartDate = true;
    if (this.envScheduleModifiedDate) {
      this.envScheduleModifiedDate[0].selected = false;
      this.selectOptionsEnvScheduleDate(this.envScheduleModifiedDate[0]);
    }
  }

  envScheduleItemEndDateChange(event) {
    this.envScheduleEndDateChange = event.value;
    this.validEnvScheduleEndDate = true;
    if (this.envScheduleModifiedDate) {
      this.envScheduleModifiedDate[0].selected = false;
      this.selectOptionsEnvScheduleDate(this.envScheduleModifiedDate[0]);
    }
  }


  envJobDetailItemStartDateChange(event) {
    this.envJobDetailStartDateChange = event.value;
    this.validEnvJobDetailStartDate = true;
    if (this.envJobDetailModifiedDate) {
      this.envJobDetailModifiedDate[0].selected = false;
      this.selectOptionsEnvJobDetailsDate(this.envJobDetailModifiedDate[0]);
    }
  }

  envJobDetailItemEndDateChange(event) {
    this.envJobDetailEndDateChange = event.value;
    this.validEnvJobDetailEndDate = true;
    if (this.envJobDetailModifiedDate) {
      this.envJobDetailModifiedDate[0].selected = false;
      this.selectOptionsEnvJobDetailsDate(this.envJobDetailModifiedDate[0]);
    }
  }
  scheduleEndDateChange(event) {
    this.scheduleEndDate = event.value;
    this.validSchEndDate = true;
    if (this.scheduleDate) {
      this.scheduleDate[0].selected = false;
      this.selectOptionsScheduleDate(this.scheduleDate[0]);
    }
  }

    jobItemStartDateChange(event) {
    this.jobStartDateChange = event.value;
    this.validJobStartDate = true;
    if (this.Date) {
      this.Date[0].selected = false;
      this.selectOptionsJobsDate(this.Date[0]);
    }
  }

  jobItemEndDateChange(event) {
    this.jobEndDateChange = event.value;
    this.validJobEndDate = true;
    if (this.Date) {
      this.Date[0].selected = false;
      this.selectOptionsJobsDate(this.Date[0]);
    }
  }

  startDateItemChange(event) {
    this.startDateTest = event.value;
    this.validStartDateChange = true;
    if (this.filterOptions) {
      this.filterOptions[0].selected = false;
      this.updateSelectedDate(this.filterOptions[0]);
    }
  }

  endDateItemChange(event) {
    this.endDateTest = event.value;
    this.validEndDateChange = true;
    if (this.filterOptions) {
      this.filterOptions[0].selected = false;
      this.updateSelectedDate(this.filterOptions[0]);
    }
  }

  scheduleDetailStartDateChange(event) {
    this.scheduleDetailStartDate = event.value;
    this.validSchDetailStartDate = true;
    if (this.scheduleDetailDate) {
      this.scheduleDetailDate[0].selected = false;
      this.selectOptionsDetailScheduleDate(this.scheduleDetailDate[0]);
    }
  }

  scheduleDetailEndDateChange(event) {
    this.scheduleDetailEndDate = event.value;
    this.validSchDetailEndDate = true;
    if (this.scheduleDetailDate) {
      this.scheduleDetailDate[0].selected = false;
      this.selectOptionsDetailScheduleDate(this.scheduleDetailDate[0]);
    }
  }

  startModifiedDateChange(event) {
    this.filterModifiedStartDate = event.value;
    this.validFilterModifiedStartDate = true;
    if (this.JBDate) {
      this.JBDate[1].selected = false;
      this.selectOptionsJBDate(this.JBDate[1]);
    }
  }

  endModifiedDateChange(event) {
    this.filterModifiedEndDate = event.value;
    this.validFilterModifiedEndDate = true;
    if (this.JBDate) {
      this.JBDate[1].selected = false;
      this.selectOptionsJBDate(this.JBDate[1]);
    }
  }

  /**
   * Configures the column filter items
   *
   * @param resetFilter - if true all selected should be set to true
   */
  private configureColumnFilterItems(resetFilter): void {
    this.columnFilterItems = this.allColumns
    .map(column => ({
        item: column,
        label: translate('INSTANCE_STATUS.' + column),
        selected: resetFilter ? true : this.filteredColumns.includes(column),
    } as FilterItem<string>));
  }
}